import datosDpto from './departamentos.json';
import datosProv from './provincias.json';
import datosDist from './distritos.json';


export function ListaDepartamentos() {
    const lista = datosDpto.departamentos.map((i) => (
        <option key={i.departamento} value={i.departamento}>
        {i.nombre}
        </option>
        ));
    return lista;
}

export function ListaProvincias({departamento}){
    const filtro = datosProv.provincias.filter(prov => prov.departamento == departamento);
    const lista = filtro.map((i) => (
        <option key={i.provincia} value={i.provincia}>
        {i.nombre}
        </option>
        ));
    return lista;
}

export function ListaDistritos({departamento, provincia}){
    const filtro = datosDist.distritos.filter(dist =>dist.departamento == departamento && dist.provincia == provincia);
    const lista = filtro.map((i) => (
        <option key={i.distrito} value={i.distrito}>
        {i.nombre}
        </option>
        ));
    return lista;
}

export function ObtenerUbicacion({dpto, prov, dist}){
    const departamento = datosDpto.departamentos.filter(d=>d.departamento == dpto);
    const provincia = datosProv.provincias.filter(p=>p.departamento == dpto && p.provincia == prov);
    const distrito = datosDist.distritos.filter(d=>d.departamento == dpto && d.provincia == prov && d.distrito==dist);
    if(departamento[0] && provincia[0] && distrito[0]){
        return(<>{departamento[0].nombre+' - '+provincia[0].nombre+' - '+distrito[0].nombre}</>);
    }else{
        return(<>{'nn'}</>);
    }
}